export const ValidationMessages = {
	EmailExist: "Email already in use",
	NotAllowedEmail: "Email is not allowed",
	InvalidEmail: "Email is Invalid",
	NotAllowedEmailForUserType:
		"This email domain is not allowed for this user type.",
	InvalidUsername: "Invalid username",
	InvalidPassword: "Invalid password",
	InvalidCode: "Code is Invalid",
	AddressNotVerified: "The address is not verified",
	NetworkTokenizationWebsiteWarning:
		"To activate Network Tokenization Website is required.",
	WebsiteMessage: "This address will be add to your Business Information",
};
